import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CloudDocumentService } from './cloud-document.service';
import { ExternalContentProviderSource } from 'src/app/constants/ExternalContentProviders.enum';

export const CloudUploadDocumentModalOptions: NgbModalOptions = {
  centered: true,
  size: 'xl',
  windowClass: 'modal-xxl'
};

@Component({
    templateUrl: './cloud-document.modal.html',
    styleUrls: ['./cloud-document.modal.css'],
    providers: [CloudDocumentService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudDocumentUploadModal implements OnInit, OnDestroy {
  @Input() allowMultiselect: boolean = true;
  @Input() acceptedDocumentTypes: string[] | undefined = [];
  @Input() enabledPlugins: any;
  @Input() modalTitleTranslationKey = 'CloudLocations.UploadTitle';
  @Output() close = new EventEmitter<any>();
  @Output() importFiles = new EventEmitter<{ provider: string, id: string, externalFiles: any, name: string }>();

  private importSubscription: Subscription | undefined;

  constructor(private cloudDocumentService: CloudDocumentService) {}

  ngOnInit(): void {
    this.cloudDocumentService.init({
      isExportMode: false,
      enabledPlugins: this.enabledPlugins ?? [],
      allowMultiselect: this.allowMultiselect
    });

    this.importSubscription = this.cloudDocumentService.importFiles$.subscribe(file => {
      this.importFiles.emit(file);
    });
  }

  ngOnDestroy(): void {
    this.importSubscription?.unsubscribe();
  }

  get hasSelectedProvider() { return this.cloudDocumentService.hasSelectedProvider; }
  get detailsCollapsed() { return this.cloudDocumentService.detailsCollapsed; }
  get searchTerm() { return this.cloudDocumentService.searchTerm; }
  set searchTerm(v: string) { this.cloudDocumentService.searchTerm = v; }
  get isHyarchisSource() { return this.cloudDocumentService.isHyarchisSource; }

  closeDialog() { this.cloudDocumentService.closeDialog(); }
  onSearchChange(value: string) { this.cloudDocumentService.onSearchChange(value); }
  toggleCloudDetails() { this.cloudDocumentService.toggleCloudDetails(); }
}
